export default function GallerySection() {
  const images = [
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Fb767d49b02e648729ec0d2082df1ad62&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F7fdaee15617449e0835739822106deb7&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F77aa8643d08043d0bf7816b5335aecba&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F0fac35fb58c9467ab5dd69cdf37aeffd&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Fc96ede1f7b344f128ed6a6237b1c35f8&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F71a3cea1a2244f2090b4eefc7c66a58b&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F6eba3817f9994f5eb9f4c8c5cf0c08c1&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Ff819463210b641ce9ed91ea6542dc3d7&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F37e3f6bd54a84633a6a4277b20fe24c0&methods=resize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Fb4175f803d704b44b9273af0f19abf22&methods=crop%2C18.1017%25%2C23.2142%25%2C75.7576%25%2C56.8182%25%7Cresize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2Fbc40b4cd1777480792a4d4bb23166bc5&methods=crop%2C23.6641%25%2C25.0393%25%2C76.3359%25%2C57.2519%25%7Cresize%2C600%2C5000',
    'https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F0958c16bd2294fe0907e0939d1393d32&methods=resize%2C600%2C5000',
  ];

  const handleViewGallery = () => {
    window.REACT_APP_NAVIGATE('/gallery');
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm font-medium tracking-wider uppercase text-amber-600 mb-3">
            Our Work
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Project Gallery
          </h2>
          <p className="text-base text-neutral-500 max-w-2xl mx-auto">
            Browse through our recent painting and decorating projects across Watford and Hertfordshire
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              className="aspect-square overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
            >
              <img
                src={image}
                alt={`Gallery image ${index + 1}`}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleViewGallery}
            className="px-8 py-4 bg-neutral-800 text-white font-semibold rounded-lg hover:bg-neutral-700 transition-colors duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            View Full Gallery
          </button>
        </div>
      </div>
    </section>
  );
}